module.exports = __webpack_public_path__ + "static/box_3-5d73c3a226f58b6961c47555d9a4ad9e.png";